<template>
<div class="field">
  <autocomplete :label="label" :placeholder="placeholder"
    v-model="text" :showSuggestions="suggestions.length > 0 && focused"
    v-on:keyup.enter="onReturnKey"
    v-on:blur="onBlur"
    v-on:focus="onFocus">
    <ul>
      <li class="row" v-for="(suggestion, index) in suggestions" :key="index"
        @click.stop.prevent="selected(suggestion)">
        <span>{{ suggestion.title }}</span>
      </li>
    </ul>
  </autocomplete>
</div>
</template>

<script>
import Autocomplete from '@/components/general/autocomplete-text-field'
import Locations from '@/api/locations'

export default {
  components: { Autocomplete },
  props: {
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: Object,
      required: false
    }
  },
  methods: {
    updateText (text) {
      if (text.length > 3 && this.focused) {
        this.updateSuggestions(text)
      } else {
        this.suggestions = []
      }
    },
    async updateSuggestions (text) {
      this.suggestions = await Locations.autocomplete(text)
    },
    onBlur () {
      window.setTimeout(() => {
        this.focused = false
      }, 250)
    },
    onFocus () {
      this.focused = true
      this.suggestions = []
    },
    selected (suggestion) {
      this.text = suggestion.title
      this.focused = false
      this.$emit('input', {
        placeId: suggestion.placeId,
        title: suggestion.title
      })
    }
  },
  watch: {
    text () {
      this.updateText(this.text)
    },
    value (newValue) {
      this.text = this.value.title
    }
  },
  mounted () {
    this.text = this.value ? this.value.title : ''
  },
  data () {
    return {
      text: '',
      suggestions: [],
      focused: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.row {
  padding: 0.5rem;
  &:hover {
    background-color: $hover-background;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/general/location-autocomplete-field.vue